import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { TranslateFormNewComponent } from './translate-form-new/translate-form-new.component';
import { TranslateFormAiComponent } from './translate-form-ai/translate-form-ai.component';

export interface LanguageInterface {
  col: string;
  id: string;
  name: string;
}

@Component({
  selector: 'app-translate-form',
  templateUrl: './translate-form.component.html',
  styleUrl: './translate-form.component.scss',
  standalone:false
})
export class TranslateFormComponent implements OnInit {

  massChange() {

    let cnt = this.selection.selected.length ;
    if (cnt == 0) {
      this.snackBar.showError("translate.nolines.selected");
      return;
    }

    this.dialogServices.title = "actions.masschange";
    this.dialogServices.openGenericDialog(TranslateFormNewComponent,
      {
        languages:this.languages,
        massChange:true
      }, (okFunction:any)=>{
        this.dialogServices.openNewDialog("translate.masschange.confirm"+":" + this.selection.selected.length,async()=>{

          for (const item of this.selection.selected) {
            if ( item['INTERNALID'] != null ){
              this.languages.forEach((lang) => {
                item[lang.col] = okFunction[lang.col] == undefined ? '' : okFunction[lang.col];
              })

              await this.saveRow(item).then((data)=>{
                this.snackBar.showSuccess("translate.edit.success"+":"+ item['ID']);
              }).catch((error)=>{
                throw new Error(error);
              })

            }

         };
         await this.loadTranslations();
        },()=>{},false);


      },()=>{},'70vh','80vw',false,null,'S','40px');
  }

  iaROW() {

    let cnt = this.selection.selected.length ;
    if (cnt == 0) {
      this.snackBar.showError("translate.nolines.selected");
      return;
    }

    this.dialogServices.openGenericDialog(TranslateFormAiComponent,
      {
        languages:this.languages,
        items:this.selection.selected
      }, async (okFunction:any)=>{
          let rows = okFunction as any[];
          await this.saveRowMutiple(okFunction).then((data)=>{
              this.snackBar.showSuccess(this.ls.instant("translate.ai.success",{count:rows.length}));
          }).catch((error)=>{
            throw new Error(error);
          })
          this.loadTranslations();


      },()=>{},'70vh','80vw',false,null,'S','40px');

  }

  @ViewChild('input') input: ElementRef;

  deleteRow() {
    let cnt = this.selection.selected.length ;
    if (cnt == 0) {
      this.snackBar.showError("translate.nolines.selected");
      return;
    }


      this.dialogServices.title = "translate.delete.title";
      this.dialogServices.openNewDialog(
        this.ls.instant("translateform.delete.confirm") + " ( "+ cnt + " ) ?",
        async () => {
             for (const item of this.selection.selected) {

                await this.deleteTranslations(item).then((data)=>{

                  let index = this.rows.findIndex((item1:any) => {
                    if ( item1['INTERNALID'] == item['INTERNALID'] ){
                      return true;
                    }});
                  if ( index != -1 ){
                    this.rows.splice(index, 1);
                  }
                }).catch((error)=>{
                  throw new Error('Error deleting row:' + error);
                })
              };
                this.refreshFilter(); // Update the table to reflect changes
                this.selection.clear(); // Clear the selection after deletion
                this.snackBar.showSuccess("translate.delete.success"+":"+ cnt);
          });

  }

  deleteTranslations(row: any):Promise<any> {
    return new Promise((resolve, reject) => {
      let ob = {
        entityName: 'Mktplanguage',
        condition: 'INTERNALID=' + row['INTERNALID'],
      };

      this.http.post(ob,'JsonBrokerServices/remove',false,true,false).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }


  addRow() {
    this.dialogServices.title = "translateform.new.title";
    this.dialogServices.openGenericDialog(TranslateFormNewComponent,
      {
        languages:this.languages
      },(okFunction:any)=>{
        this.saveRow(okFunction).then((data)=>{
          this.loadTranslations().then(()=>{
            this.snackBar.showSuccess("translate.add.success"+":"+ data['ID']);
          });
        })
        .catch((error)=>{
          throw new Error(error);
        });


      },()=>{},'70vh','80vw',false,null,'S','40px');

  }


  languages: LanguageInterface[];
  rows: any[] = [];
  filteredRows: any[] = [];
  selection = new SelectionModel<{}>(true, []);
  temporaryRow=null;
  loading = false;
  filterText = '';
  pageIndex = 1;
  pageSize = 50;

  sortFns: { [col: string]: (a: any, b: any) => number } = {};
  sortByInternalId = (a: any, b: any) => Number(a['INTERNALID']) - Number(b['INTERNALID']);
  sortByTag = (a: any, b: any) => String(a['ID'] ?? '').localeCompare(String(b['ID'] ?? ''));

  applyFilter(event: Event) {
    this.filterText = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.refreshFilter();
    this.pageIndex = 1;
  }

  private refreshFilter() {
    const filter = this.filterText;
    if (!filter) {
      this.filteredRows = [...this.rows];
      return;
    }
    const words = filter.split(" ");
    const includeWord  = words.find(word => !word.startsWith('-'));
    const excludeWords = words.filter(word => word.startsWith('-')).map(word => word.substring(1)).filter(word => word !== '');
    this.filteredRows = this.rows.filter((data: any) => {
      const dataString = JSON.stringify(data).toLowerCase();
      return (includeWord ? dataString.includes(includeWord) : true) &&
             !excludeWords.some(word => dataString.includes(word));
    });
  }

  constructor(  private http:HTTPService,
                private ls:LanguageServices,
                private dialogServices:DialogService,
                private snackBar:SnackbarService){}

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.filteredRows.length;
    return numRows > 0 && numSelected === numRows;
  }

  /** Selects all filtered rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.clear();
    this.selection.select(...this.filteredRows);
  }

  /** TTL do cache de idiomas no localStorage (1 hora). */
  private static readonly LANGUAGES_CACHE_TTL_MS = 60 * 60 * 1000;

  /** Retorna os idiomas do cache se ainda válidos (formato novo com timestamp e TTL); senão null. */
  private getCachedLanguages(): LanguageInterface[] | null {
    try {
      const raw = localStorage.getItem('languages');
      if (raw == null) { return null; }
      const parsed = JSON.parse(raw);
      if (parsed == null || !Array.isArray(parsed.languages) || typeof parsed.timestamp !== 'number') {
        return null; // formato antigo (array puro) ou inválido → recarrega do servidor
      }
      if ((Date.now() - parsed.timestamp) > TranslateFormComponent.LANGUAGES_CACHE_TTL_MS) {
        return null; // cache expirado
      }
      return parsed.languages as LanguageInterface[];
    } catch {
      return null; // parse falhou → recarrega do servidor
    }
  }

  async ngOnInit() {

    const cached = this.getCachedLanguages();
    if ( cached == null ){
      this.languages = this.ls.languages.map((item,index) => {
        return {
          col: item.id.toUpperCase().replace('-',''),
          id: item.id,
          name: item.name,
        };
      });
      localStorage.setItem('languages', JSON.stringify({ timestamp: Date.now(), languages: this.languages }));
    }else{
      this.languages = cached;
    }

    this.languages.forEach((item) => {
      this.sortFns[item.col] = (a: any, b: any) => String(a[item.col] ?? '').localeCompare(String(b[item.col] ?? ''));
    });

    await this.loadTranslations();

  }



  async loadTranslations() {
    this.loading = true;
    return new Promise((resolve, reject) => {
      let ob = {
        entityName: 'Mktplanguage',
        condition:'0=0',
        rows: 99999,
      }

        this.http.post(ob,'JsonBrokerServices/find',false,true,false).subscribe({
          next: (data) => {
            let translations = data['Mktplanguage'].map((item: any) => {
              for (let i = 0; i < this.languages.length; i++) {
                let lang = this.languages[i];
                let languageData:object[] = JSON.parse(item['LANGUAGE']);
                let languageItem = languageData.find((langItem: any) => langItem['language'] === lang.id);


                item[lang.col] = languageItem == null || languageItem['text'] == undefined ? '' : languageItem['text'];
              }
              return item;

            });
            resolve(translations);
            this.rows = translations;
            this.filterText = '';
            this.pageIndex = 1;
            this.refreshFilter();
            this.selection.clear();
            if ( this.input != null ){
              this.input.nativeElement.value = '';
            }

          },
          error: (error) => {
            this.loading = false;
            reject(error);
          },
          complete: () => {
            this.loading = false;
          }
        });
    });
  }

  editRow(event,row: any, evento:string) {
    event.stopPropagation(); // Prevent the click event from propagating to the row


    if( evento == 'edit' ){
      row['editMode'] = true;
      this.temporaryRow = { ...row }; // Create a copy of the row to store temporary changes
      delete this.temporaryRow['editMode'];
    }else{
      row['editMode'] = false;
        this.saveRow(row).then((data)=>{
        }).catch((error)=>{
          throw error;
        });
    }
  }

  cancelEditRow(event,row: any) {
    event.stopPropagation(); // Prevent the click event from propagating to the row


    if ( this.temporaryRow != null ){
      let index = this.rows.findIndex((item:any) => {
        if ( item['INTERNALID'] == row['INTERNALID'] ){
          return true;
        }});
      if ( index != -1 ){
        this.rows[index]= this.temporaryRow;
      }
      this.refreshFilter(); // Update the table to reflect changes
    }
    this.temporaryRow = null;
    row['editMode'] = false;
  }

  async saveRow(row: any):Promise<any> {

    row['LANGUAGE'] = JSON.stringify(

        this.languages.map((item) => {
            let newLanguage = {
                  language: item.id,
                  text: row[item.col] == undefined ? '' : row[item.col]
                }
                return newLanguage;
              }
          )
    );

    if (row['editMode'] != null){
      delete row['editMode'];
    }
    if ( row['select'] != null ){
      delete row['select'];
    }


    return new Promise((resolve, reject) => {
      let ob = {
        entityName: 'Mktplanguage',
        CODECOMPANY: 0
      };

      if ( row['INTERNALID'] != null ){
        ob['condition']= 'INTERNALID=' + row['INTERNALID'];
      }


      let mergedObject = Object.assign({}, ob, row);

      this.http.post(mergedObject,'JsonBrokerServices/save',false,true,false).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }


  async saveRowMutiple(rows: any[]):Promise<any> {

    for ( var row of rows ){
        row['LANGUAGE'] = JSON.stringify(

            this.languages.map((item) => {
                let newLanguage = {
                      language: item.id,
                      text: row[item.col] == undefined ? '' : row[item.col]
                    }
                    return newLanguage;
                  }
              )
        );

        if (row['editMode'] != null){
          delete row['editMode'];
        }
        if ( row['select'] != null ){
          delete row['select'];
        }
        row['CODECOMPANY'] = 0;
    }

    let ob = {
      entityName: 'Mktplanguage',
      data: rows
    }

    return new Promise((resolve, reject) => {

      this.http.post(ob,'JsonBrokerServices/save',false,true,false).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }
}
